import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {Router} from '@angular/router';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { SupportMenuComponent } from './support-menu/support-menu.component';
import { AuthService, NotificationService, UserService } from '@app/core/services';
import { User } from '@app/shared/models/Authentication/user.model';
import { AppSettings } from '@app/services/app-settings.service';

declare var $: any;
declare var slideToggle: any;

@Component({
  selector: 'sa-header',
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit , OnDestroy {
  user : User;
  @Input() appSidebarTwo;
	@Output() appSidebarEndToggled = new EventEmitter<boolean>();
	@Output() appSidebarMobileToggled = new EventEmitter<boolean>();
	@Output() appSidebarEndMobileToggled = new EventEmitter<boolean>();
  
  bsModalRef: BsModalRef;
  constructor(private router: Router,private modalService: BsModalService, 
    public appSettings: AppSettings,
    public us: UserService,
    private notificationService : NotificationService,
    private authService: AuthService) {
      this.user = this.authService.currentUser;
  }

  searchMobileActive = false;
  toggleAppSidebarEndMobile() {
		this.appSidebarEndMobileToggled.emit(true);
  }
  toggleAppSidebarMobile() {
		this.appSidebarMobileToggled.emit(true);
  }
  
	toggleAppSidebarEnd() {
		this.appSidebarEndToggled.emit(true);
	}
	
  

	toggleAppTopMenuMobile() {
		var target = document.querySelector('.app-top-menu');
		if (target) {
			slideToggle(target);
		}
	}

	toggleAppHeaderMegaMenuMobile() {
	  this.appSettings.appHeaderMegaMenuMobileToggled = !this.appSettings.appHeaderMegaMenuMobileToggled;
	}

	ngOnDestroy() {
	  this.appSettings.appHeaderMegaMenuMobileToggled = false;
	}

  ngOnInit() {
  }
  editProfile():void{
    this.router.navigate(['/profile/']);
}
logout(){
this.router.navigate(["/authentication/logout"],{state:{ local: true }});
}
showPopup() {
  
  this.notificationService.smartMessageBox(
    {
      title: `<i class='fa fa-sign-out txt-color-orangeDark'></i> Logout <span class='txt-color-orangeDark'><strong>${this.authService.currentUser.fullName}</strong></span>?`,
      content: 'You can improve your security further after logging out by closing this opened browser.',
    },
    buttonPressed => {
      if (buttonPressed === 'Yes') {
        this.logout();
      }
    }
  );
}
  toggleSearchMobile() {
    this.searchMobileActive = !this.searchMobileActive;

    $('body').toggleClass('search-mobile', this.searchMobileActive);
  }

  onSubmit() {
    this.router.navigate(['/miscellaneous/search']);

  }
  showSupportInfo(){
    const initialState = {
      title: 'Help and Support'
    };
    this.bsModalRef = this.modalService.show(SupportMenuComponent, {initialState});
    this.bsModalRef.content.closeBtnName = 'Close';
  }
  get logo(){
    return this.authService.currentUser == null ? "" : this.authService.currentUser.logo;
  }
  get businessEntity(){
    return this.authService.currentUser?.entityName;
  }
}
